/**
 * Determines urgency level based on session time remaining.
 * Uses consistent "lessXX" naming pattern for all thresholds.
 *
 * @param timeRemainingMs - Time remaining until session expiry in milliseconds
 * @returns Urgency level string with consistent naming pattern
 */
export const getSessionUrgencyLevel = (timeRemainingMs: number): string => {
	if (timeRemainingMs <= 15 * 60 * 1000) return 'less15m'; // ≤ 15 minutes (dismiss blocked)
	if (timeRemainingMs <= 30 * 60 * 1000) return 'less30m'; // ≤ 30 minutes
	if (timeRemainingMs <= 60 * 60 * 1000) return 'less1h'; // ≤ 1 hour
	if (timeRemainingMs <= 120 * 60 * 1000) return 'less2h'; // ≤ 2 hours
	return 'normal'; // > 2 hours
};
